module.exports = __webpack_public_path__ + "static/bluehat-6f7a7621bc5a9cacf645840de45692db.jpeg";